module.exports = __webpack_public_path__ + "img/20210901_075616.99a31258.jpg";